import React, { Component } from 'react';
import classNames from 'classnames';
import Button from './Button';

class PrettyDropDown2 extends Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.state = {
      active: true,
      title: "select",
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.updateTitleFromProps(this.props);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.value !== this.props.value ||
      prevProps.options !== this.props.options
    ) {
      this.updateTitleFromProps(this.props);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  updateTitleFromProps = (props) => {
    const { value, options = [] } = props;

    if (value === null || value === undefined || value === "") {
      this.setState({ title: "select" });
      return;
    }

    const optionSelected = options.find((option) => option.code === value);

    this.setState({
      title: optionSelected ? optionSelected.description : "select",
    });
  };

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      if (this.state.active === false) {
        this.setState(prevState => ({
          active: !prevState.active
        }));
      }
    }
  }

  onDropDownClick = () => {
    this.setState(prevState => ({
      active: !prevState.active
    }));
  }

  onMenuItemClick = (option) => {
    this.onDropDownClick();
    this.setState({ title: option.description });
    this.props.onSelectItem(option.code);
  }

  render() {
    const { active } = this.state;
   
    return (
      <div ref={this.setWrapperRef} className="pretty-dropdown__container">
        <Button
          buttonClass="pretty-dropdown__button"
          text={this.state.title}
          handleClick={this.onDropDownClick}
        />
        <ul className={classNames('pretty-dropdown', { 'active': active })} name="dropdown">
          {this.props.options.map((option, index) => {
            return (
              <li
                key={index}
                onClick={() => this.onMenuItemClick(option)}
                className={classNames("pretty-dropdown__list", { 'active': active })}
                tabIndex={index}
              >
                {option.description}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default PrettyDropDown2;